import styled from 'styled-components'
import { ComponentProps } from 'react'
import Language from '../enums/Language'
import { LANGUAGES } from '../constants/i18n'

const FlagIcon = styled.img<ComponentProps<'img'>>`
  border-radius: 50%;
  width: 18.56px;
  height: 18.56px;
`

interface FlagProps {
  language: Language
  // size?: 'small' | 'medium' | 'large'
}

export default function Flag({ language }: FlagProps) {
  /**
   * The flag of country.
   */
  const flag = LANGUAGES[language]

  return <FlagIcon src={flag.icon} alt={flag.name} />
}
